module.exports = __webpack_public_path__ + "img/sample-sukkirimarugo.b10ddf09.svg";